import type { PaidBreakExceptionReason } from '#/shared/types/PaidBreakRequest';

type PaidBreakExceptionDetailsProps = {
  reason?: PaidBreakExceptionReason;
  notes?: string;
};

function getReasonDisplayText(reason: Readonly<PaidBreakExceptionReason>): string {
  switch (reason) {
    case 'other':
      return 'Other';
    case 'night_shift':
      return 'Night shift';
    case 'no_break_reason':
      return "Didn't take break";
  }
}

export function PaidBreakExceptionDetails({ reason, notes }: Readonly<PaidBreakExceptionDetailsProps>) {
  return (
    <>
      {reason && <p className="text-base text-on-surface-variant">Request reason: {getReasonDisplayText(reason)}</p>}
      {notes && <p className="text-base mb-8 text-on-surface-variant">Doctor's note: "{notes}"</p>}
    </>
  );
}
